import { Form as FormikAntdForm } from 'formik-antd/lib/form';
import { FormItem } from './form-item';

// formik-antd is not compatible with the current Ant Design version when Form.Item receives a name prop.
// This adapter keeps the public formik-antd imports stable while replacing FormItem with our compatibility implementation.
export {
  AddRowButton,
  ArrayButton,
  AutoComplete,
  Cascader,
  Checkbox,
  DatePicker,
  Field,
  FormikDebug,
  HtmlText,
  Input,
  InputNumber,
  Mentions,
  Radio,
  Rate,
  RemoveRowButton,
  ResetButton,
  Select,
  Slider,
  SubmitButton,
  Switch,
  Table,
  TimePicker,
  Transfer,
  TreeSelect,
  isDevelopmentMode,
} from 'formik-antd/lib/index';
export { FormItem, type FormItemProps } from './form-item';

export const Form = FormikAntdForm;

Form.Item = FormItem;
